import Vue from 'vue'
import Router from 'vue-router'
import Layout from 'views/Layout'
import Login from 'views/Login'
import Home from 'views/Home'
import HelloWorld from 'views/HelloWorld'
import Department from 'views/Department'
import Role from 'views/Role'
import User from 'views/User'
import Customer from 'views/Customer'
import Order from 'views/Order'
import Product from 'views/Product'
import ProductNew from 'views/ProductNew'

import Brand from 'views/Brand'
import Category from 'views/Category'
import HomeCategory from 'views/HomeCategory'
import HomeBanner from 'views/HomeBanner'
import HomeMessage from 'views/HomeMessage'
import HomeProduct from 'views/HomeProduct'

import RedEnvelope from 'views/RedEnvelope'
import RedEnvelopeOpen from 'views/RedEnvelopeOpen'
import RedEnvelopeNew from 'views/RedEnvelopeNew'
import RedEnvelopeCategory from 'views/RedEnvelopeCategory'

import QRCode from 'views/QRCode'

import Lottery from 'views/Lottery'
import LotteryDraw from 'views/LotteryDraw'
import LotteryNew from 'views/LotteryNew'
import LotteryPrize from 'views/LotteryPrize'
import LotteryPrizeManage from 'views/LotteryPrizeManage'

import Shop from 'views/Shop'

import VoteBanner from 'views/VoteBanner'
import VotePrize from 'views/VotePrize'
import VotePresent from 'views/VotePresent'
import VotePresentOrder from 'views/VotePresentOrder'
import VoteResult from 'views/VoteResult'
import VotePlayer from 'views/VotePlayer'
import Vote from 'views/Vote'
import VoteNew from 'views/VoteNew'
import VotePrizeXref from 'views/VotePrizeXref'
import VotePresentXref from 'views/VotePresentXref'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/hello',
          name: 'hello',
          component: HelloWorld
        },
        {
          path: '/brand/manage',
          name: 'brand.manage',
          component: Brand
        },
        {
          path: '/category/manage',
          name: 'category.manage',
          component: Category
        },
        {
          path: '/department/manage',
          name: 'department.manage',
          component: Department
        },
        {
          path: '/role/manage',
          name: 'role.manage',
          component: Role
        },
        {
          path: '/user/manage',
          name: 'user.manage',
          component: User
        },
        {
          path: '/customer/list',
          name: 'customer.list',
          component: Customer
        },
        {
          path: '/order/list',
          name: 'orer.list',
          component: Order
        },
        {
          path: '/product/manage',
          name: 'product.manage',
          component: Product
        },
        {
          path: '/product/new',
          name: 'product.new',
          component: ProductNew
        },
        {
          path: '/marketing/category',
          name: 'marketing.category',
          component: HomeCategory
        },
        {
          path: '/marketing/banner',
          name: 'marketing.banner',
          component: HomeBanner
        },
        {
          path: '/marketing/message',
          name: 'marketing.message',
          component: HomeMessage
        },
        {
          path: '/marketing/product',
          name: 'marketing.product',
          component: HomeProduct
        },
        {
          path: '/redenvelope/list',
          name: 'redenvelope.list',
          component: RedEnvelope
        },
        {
          path: '/redenvelope/open',
          name: 'redenvelope.open',
          component: RedEnvelopeOpen
        },
        {
          path: '/redenvelope/new',
          name: 'redenvelope.new',
          component: RedEnvelopeNew
        },
        {
          path: '/redenvelope/category',
          name: 'redenvelope.category',
          component: RedEnvelopeCategory
        },
        {
          path: '/redenvelope/qrcode',
          name: 'redenvelope.qrcode',
          component: QRCode
        },
        {
          path: '/lottery/list',
          name: 'lottery.list',
          component: Lottery
        },
        {
          path: '/lottery/prize/manage',
          name: 'lottery.prize.manage',
          component: LotteryPrizeManage
        },
        {
          path: '/lottery/draw',
          name: 'lottery.draw',
          component: LotteryDraw
        },
        {
          path: '/lottery/new',
          name: 'lottery.new',
          component: LotteryNew
        },
        {
          path: '/lottery/prize',
          name: 'lottery.prize',
          component: LotteryPrize
        },
        {
          path: '/shop/list',
          name: 'shop.list',
          component: Shop
        },
        {
          path: '/vote/findBanner',
          name: 'vote.banner.find',
          component: VoteBanner
        },
        {
          path: '/vote/findPrize',
          name: 'vote.prize.find',
          component: VotePrize
        },
        {
          path: '/vote/findPresent',
          name: 'vote.present.find',
          component: VotePresent
        },
        {
          path: '/vote/order',
          name: 'vote.present.order',
          component: VotePresentOrder
        },
        {
          path: '/vote/result',
          name: 'vote.result.find',
          component: VoteResult
        },
        {
          path: '/vote/findPlayer',
          name: 'vote.player.find',
          component: VotePlayer
        },
        {
          path: '/vote/list',
          name: 'vote.list',
          component: Vote
        },
        {
          path: '/vote/new',
          name: 'vote.new',
          component: VoteNew
        },
        {
          path: '/vote/prize/xref',
          name: 'vote.prize.xref',
          component: VotePrizeXref
        },
        {
          path: '/vote/present/xref',
          name: 'vote.present.xref',
          component: VotePresentXref
        },
      ]
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js